import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
const OrganicBlob = ({ level, size }) => {
  const t = useRef(0);
  const [d, setD] = useState("");
  useEffect(() => {
    let raf;
    const tick = () => {
      t.current += 0.012;
      const points = 8;
      const cx = 50;
      const cy = 50;
      const baseR = 28 + level * 8;
      const wobble = 3 + level * 9;
      const pts = [];
      for (let i = 0; i < points; i++) {
        const a = i / points * Math.PI * 2;
        const noise = Math.sin(t.current * 1.3 + i * 1.7) * wobble + Math.sin(t.current * 0.7 + i * 0.9) * wobble * 0.5;
        const r = baseR + noise;
        pts.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]);
      }
      let path = `M ${pts[0][0].toFixed(2)} ${pts[0][1].toFixed(2)}`;
      for (let i = 0; i < points; i++) {
        const p0 = pts[(i - 1 + points) % points];
        const p1 = pts[i];
        const p2 = pts[(i + 1) % points];
        const p3 = pts[(i + 2) % points];
        const c1x = p1[0] + (p2[0] - p0[0]) / 6;
        const c1y = p1[1] + (p2[1] - p0[1]) / 6;
        const c2x = p2[0] - (p3[0] - p1[0]) / 6;
        const c2y = p2[1] - (p3[1] - p1[1]) / 6;
        path += ` C ${c1x.toFixed(2)} ${c1y.toFixed(2)}, ${c2x.toFixed(2)} ${c2y.toFixed(2)}, ${p2[0].toFixed(2)} ${p2[1].toFixed(2)}`;
      }
      path += " Z";
      setD(path);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [level]);
  return /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: "0 0 100 100", "aria-hidden": true, children: [
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("radialGradient", { id: "organic-g", cx: "35%", cy: "35%", children: [
        /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#ffffff", stopOpacity: "0.9" }),
        /* @__PURE__ */ jsx("stop", { offset: "40%", stopColor: "var(--voice-orb-primary, #7c5cff)", stopOpacity: "1" }),
        /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#1a0b4d", stopOpacity: "1" })
      ] }),
      /* @__PURE__ */ jsx("filter", { id: "organic-glow", children: /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "1.2" }) })
    ] }),
    /* @__PURE__ */ jsx("path", { d, fill: "url(#organic-g)", filter: "url(#organic-glow)" })
  ] });
};
export {
  OrganicBlob
};
//# sourceMappingURL=OrganicBlob.js.map
